import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { socialLinks, personalInfo } from "../../data/portfolioData";
import "./Footer.css";
import { useLanguage } from "../../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <span className="footer__logo">
            &lt;{personalInfo.name.split(" ")[0]} /&gt;
          </span>
          <div className="footer__socials">
            <a href={socialLinks.github} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={socialLinks.gmail} aria-label={`Email ${personalInfo.email}`}>
              <FaEnvelope />
            </a>
          </div>
        </div>
        <div className="footer__divider" />
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} {personalInfo.name}. {t.footer}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
